const eligibleCollections = new Set(['injection-pump', 'injection-packers']);
const handle = window.location.pathname.split('/collections/')[1]?.split('/')[0];

if (eligibleCollections.has(handle)) {
  const header = document.querySelector('main[data-template^="collection"] h1');
  const container = header?.closest('.section-content-wrapper');
  const guide = [...(container?.querySelectorAll('rte-formatter.rte') || [])].find((element) =>
    element.querySelector('h2')
  );

  if (guide) {
    const guideId = `CollectionSeoGuide-${handle}`;
    const toggle = document.createElement('button');

    guide.id = guideId;
    guide.classList.add('collection-seo-guide', 'is-collapsed');
    toggle.className = 'collection-seo-guide__toggle';
    toggle.type = 'button';
    toggle.setAttribute('aria-controls', guideId);
    toggle.setAttribute('aria-expanded', 'false');
    toggle.textContent = 'Read full buying guide';

    toggle.addEventListener('click', () => {
      const expanded = toggle.getAttribute('aria-expanded') === 'true';
      toggle.setAttribute('aria-expanded', String(!expanded));
      guide.classList.toggle('is-collapsed', expanded);
      toggle.textContent = expanded ? 'Read full buying guide' : 'Show less';
    });

    guide.insertAdjacentElement('afterend', toggle);
  }
}
